import Experience from "../../Experience.js";
import constraints from "../Objects/managers/constraints.js";
import { getProducts } from "../../bdd/getProducts.js";
import Tooltip from "./Tooltip.js";

export default class MenuManager {
  constructor(_canvas) {
    this.experience = new Experience();
    this.camera = this.experience.camera;
    this.containerAboveMenu = document.getElementById("aboveMenuContainer");
    this.containerRowAboveMenu = document.getElementById(
      "aboveMenuContainerRow"
    );

    this.lastCategory = "homeProducts";
    this.constraints = constraints;
    this.measures = this.experience.measures;

    this.includedProducts = null;
    this.nonIncludedProducts = null;
    this.tooltip = new Tooltip();

    // Event buttons Menu
    document.querySelectorAll(".btnMenu").forEach((button) => {
      button.addEventListener("click", (e) => {
        // Get category
        const category = button.getAttribute("data-category");
        this.lastCategory = category;

        // Update Menu (Selected button)
        document
          .querySelectorAll(".btnMenu")
          .forEach((btn) => btn.classList.remove("selected"));
        button.classList.add("selected");

        // if showerPanel : open form measures
        if (category == "homeProducts") {
          // Show products of the selected category
          this.displayProducts(category, "productContainer", 0);
        } else {
          this.displayProducts(category, "productContainer", 1);
        }
      });
    });

    this.initialize().then(() => {
      this.displayProducts(this.lastCategory, "productContainer");
    });

    /**
     * Back Menu (textures walls, partitions etc.)
     */
    document
      .getElementById("productContainer")
      .addEventListener("click", (e) => {
        const button = e.target.closest(".buttonBackMenuTextures");
        if (button) {
          this.displayProducts(this.lastCategory, "productContainer");
        }
      });
  }

  async initialize() {
    try {
      // Récupérer les produits inclus dans le devis
      this.includedProducts = await getProducts(1);

      // Récupérer les produits non inclus dans le devis
      this.nonIncludedProducts = await getProducts(0);
    } catch (error) {
      console.error("Erreur lors de la récupération des produits :", error);
    }
  }

  /**
   * Show products of a category
   * isIncludedInPrice (devis)
   */
  displayProducts(
    category,
    div,
    isIncludedInPrice = 1,
    clickedOnScene = 0,
    subType = null
  ) {
    if (
      document.querySelector(".scrollable-menu").classList.contains("d-none")
    ) {
      document.querySelector(".scrollable-menu").classList.remove("d-none");
    }

    if (category == "homeProducts") {
      isIncludedInPrice = 0;
    }

    if (category === "showerPanel" && !clickedOnScene) {
      this.displayScaleForm(
        "productContainer",
        category,
        this.constraints[category].formContent,
        true
      );
      return;
    }

    // hide tooltip
    this.tooltip.removeTooltip();

    const container = document.getElementById(div);

    if (clickedOnScene) {
      document.querySelector(".scrollable-menu").classList.add("d-none");
      container.innerHTML =
        "<button  class='btn buttonBackMenuTextures'><img class='align-self-center' src='./images/icons/iconBack.png' width='15' /></button><br><div class='mt-5'></div><br><p class='text-start barlow-bold' style='color:#fff;font-size:14px'>⚠️ Sélectionner l'objet pour changer sa texture. </p>";
    } else {
      container.innerHTML = "";
      document.querySelector(".scrollable-menu").classList.remove("d-none");
    }

    let products;

    if (isIncludedInPrice) {
      // Product included
      const getProductsCategory =
        category === "partition" || category === "pipeBoxing" || (category === "showerPanel" && subType == "wall") 
          ? "wall"
          : category;
          
      products = this.includedProducts[getProductsCategory];

      if (!products) {
        container.innerHTML += `<p style="color:#ffffff">Aucun produit disponible pour cette catégorie.</p>`;
        return;
      }
    } else {
      // Product no included : Group by category
      const groupedProducts = {};

      Object.keys(this.nonIncludedProducts).forEach((cat) => {
        this.nonIncludedProducts[cat].forEach((product) => {
          if (!groupedProducts[cat]) groupedProducts[cat] = [];
          groupedProducts[cat].push(product);
        });
      });
      products = groupedProducts;
    }

    if (isIncludedInPrice) {
      // For included product (standard display)

      // For showerWall (sort by type)
      const showerWallSubTypes = this.constraints["showerWall"].subType || [];

      if (category === "showerWall") {
        const filteredProducts = products.filter((product) =>
          showerWallSubTypes.includes(product.subType)
        );

        const sortedProducts = filteredProducts.sort(
          (a, b) =>
            showerWallSubTypes.indexOf(a.subType) -
            showerWallSubTypes.indexOf(b.subType)
        );


        sortedProducts.forEach((product) => {
          container.innerHTML += this.generateProductHTML(
            product,
            category,
            isIncludedInPrice,
            product.subType
          );
        });
      } else {
        products.forEach((product) => {
          if (subType !== null && product.subType !== null) {
            // For textures showerPanel
            if (product.subType === subType && category === "showerPanel") {
              container.innerHTML += this.generateProductHTML(
                product,
                category,
                isIncludedInPrice,
                subType
              );
            }
          } else {
            // Others
            container.innerHTML += this.generateProductHTML(
              product,
              category,
              isIncludedInPrice
            );
          }
        });
      }
    } else {
      // For no included product

      // form for partition
      container.innerHTML = `<p class="barlow-regular text-light text-center " style="color:#EBE2D9 !important; font-size:12px">
      Placez les objets déjà existants et non remplacés. <br>Objets hors devis
      </p>`;

      // Add form partition
      this.displayScaleForm(
        "productContainer",
        "partition",
        this.constraints["partition"].formContent,
        false
      );

      // Add form pipeBoxing
      this.displayScaleForm(
        "productContainer",
        "pipeBoxing",
        this.constraints["pipeBoxing"].formContent,
        false
      );

      let html = "";
      Object.keys(products).forEach((cat) => {
        html = "";
        // Ajouter le titre de la catégorie
        html += `<div class="mt-3 divider category-title bebas-neue-regular">${this.constraints[cat].title}</div>`;
        html += `<div class="row">`;

        // Ajouter les produits de la catégorie

        products[cat].forEach((product) => {
          html += this.generateProductHTML(product, cat, isIncludedInPrice);
        });
        html += `</div>`;

        container.innerHTML += html;
        
        if (this.constraints[cat].tooltip) {
          this.tooltip.createTooltip(this.constraints[cat].formContent);
        }
      });
    }

    if (this.constraints[category]?.tooltip) {
        
       this.tooltip.createTooltip(this.constraints[category].formContent);

    }
  }

  backMenu() {
    console.log("back");
  }

  generateProductHTML(product, category, isIncludedInPrice, subType = null) {

    const typeSrc = this.constraints[category]?.typeSrc || "jpg";
    const showAddButton = this.constraints[category]?.showAddButton || subType === "rabat";
    const showReplaceButton = this.constraints[category]?.showReplaceButton;
    const formContent = (this.constraints[category]?.tooltip && subType !== "rabat") || null;
    const pathSrc =
      subType !== null
        ? `./products/${product.type}/${subType}/${product.id}`
        : `./products/${product.type}/${product.id}`;
    const dataSubType = subType !== null ? `data-subtype="${subType}"` : "";


    const addButtonHTML = showAddButton
      ? `<button class="btn addObject protected" ${dataSubType} data-src="${pathSrc}/product.${typeSrc}" data-id="${product.id}"  data-type="${category}">
            <img src="./images/icons/icon_add_object_3.png" alt="Ajouter" width="30" />
         </button>`
      : "";

    const openTooltip = formContent
      ? `<button data-src="${pathSrc}/product.${typeSrc}" ${dataSubType} data-id="${product.id}" data-type="${category}" class="btn openTooltip protected">
            <img src="./images/icons/icon_add_object.png" alt="Ouvrir" width="30" />
         </button>`
      : "";

    const replaceButtonHTML = showReplaceButton
      ? `<button class="btn replaceObject protected" data-src="${pathSrc}/product.${typeSrc}" data-id="${product.id}" data-type="${category}"> <img src="./images/icons/icon_replace_object.png" alt="Remplacer" width="30" /> </button>`
      : "";

    let cardHTML = `<div class="col-6 px-1 mt-2">
        <div class="card cardProduct">
          <div class="card-body p-0" data-src="${pathSrc}/product.${typeSrc}" data-id="${product.id}" data-type="${category}" >
            <img src="${pathSrc}/miniature.jpg" width="100%" />
            <br>
            ${addButtonHTML}
            ${openTooltip}
            ${replaceButtonHTML}
          </div>`;
    if (isIncludedInPrice) {
      cardHTML += `<div class="text-start bebas-neue-regular ms-3 mt-3 pb-2">
            <p class="text-uppercase productName m-0">${product.titre}</p>
            <span class="barlow-regular px-2 py-1 " style="font-size:12px;background-color:#004555;color:#ffffff">${product.id}</span>
          </div>`;
    }

    cardHTML += `</div>
      </div>`;
    return cardHTML;
  }

  /**
   * Open container for change textures (of walls, partition, pipeBoxing, showerPanel)
   */
  openContainerChangeTexture(type, subType) {
    /*  containerTextures.innerHTML = ""; */
    /* this.containerAboveMenu.classList.remove("d-none"); */

    this.displayProducts(type, "productContainer", 1, 1, subType);
  }

  closeContainerAboveMenu() {
    /* this.containerAboveMenu.classList.add("d-none"); */
    //this.displayProducts(this.lastCategory, "productContainer");
  }

  /**
   * Create form scale
   */

  displayScaleForm(div, type, htmlForm, contentDivIsDelete) {
    this.tooltip.removeTooltip();
    const container = document.getElementById(div);
    if (contentDivIsDelete) {
      container.innerHTML = "";
    }
    container.innerHTML += `<div class="mt-3 divider category-title bebas-neue-regular">${this.constraints[type].title}</div>`;
    container.innerHTML += htmlForm;
  }

  /**
   * Open container for hide measures in 2d plan
   */
  openContainerHideMeasures2dPlan() {
    document.querySelector(".scrollable-menu").classList.remove("d-none");
    if (this.camera.is2DView) {
      this.tooltip.removeTooltip();
      this.containerAboveMenu.classList.remove("d-none");
      this.containerRowAboveMenu.innerHTML =
        '<div class="text-center">' +
        '<button id="hideMeasures" style="" class="btn mt-5 text-center">Masquer les mesures actuelles</button>' +
        '<p class="barlow-regular text-center text-light mx-auto mt-4" style="max-width:300px">Sélectionner ou désélectionner les objets pour afficher leurs côtes et positions.</p>' +
        "</div>";

      // Ajouter l'écouteur ici, après la création du bouton
      const button = document.getElementById("hideMeasures");
      button.addEventListener("click", (e) => {
        // hide measures
        this.measures.toggleVisibility();

        e.target.textContent = this.measures.visible
          ? "Masquer les mesures actuelles"
          : "Afficher les mesures actuelles";
      });
    } else {
      this.containerRowAboveMenu.innerHTML = "";

      this.closeContainerAboveMenu();
      this.containerAboveMenu.classList.add("d-none");
      this.displayProducts(this.lastCategory, "productContainer");
    }
  }

  resize() {
    this.tooltip.removeTooltip();
  }

  removeTooltip() {
    this.tooltip.removeTooltip();
  }
}
